import { useFormikContext } from 'formik';
import TemplateGallery from '../../template-gallery/TemplateGallery';
import { fetchTemplates } from '@/features/admin/templates/slice';
import { useAppDispatch } from '@/hooks';
import { useEffect, useState } from 'react';
import { CircularProgress, Stack } from '@mui/material';

const Templates = () => {
  const dispatch = useAppDispatch();
  const { setFieldValue } = useFormikContext<{ template: string }>();
  const [isLoading, setIsLoading] = useState(true);

  const onSelect = (templateId: string) => {
    setFieldValue('template', templateId);
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(fetchTemplates()).then(() => setIsLoading(false));
  }, []);

  if (isLoading) {
    return (
      <Stack
        direction="row"
        flex={1}
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress />
      </Stack>
    );
  }

  return <TemplateGallery onSelect={onSelect} type={'select'} />;
};

export default Templates;
